import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { format } from 'date-fns';

const BookingConfirmation = ({
  classData,
  bookingId,
  paidAmount,
  appliedDiscount,
  userEmail
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className="text-center py-16"
    >
      <div className="bg-background-paper border border-success/30 rounded-sm p-12 max-w-2xl mx-auto">
        <div className="w-20 h-20 bg-success/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <span className="text-5xl">✅</span>
        </div>
        <h1 className="font-heading text-4xl font-black mb-4">PAYMENT CONFIRMED!</h1>
        <p className="text-lg text-neutral-300 mb-6">
          Your booking for <span className="text-primary font-bold">{classData?.title}</span> has been confirmed.
        </p>
        <div className="bg-background border border-white/10 rounded-sm p-6 mb-8 text-left">
          <p className="text-sm text-neutral-400 mb-2">Booking ID</p>
          <p className="font-mono text-lg text-primary mb-4">{bookingId}</p>
          <p className="text-sm text-neutral-400 mb-2">Date & Time</p>
          <p className="text-lg mb-4">{format(new Date(classData?.class_datetime), 'MMM dd, yyyy - h:mm a')}</p>
          <p className="text-sm text-neutral-400 mb-2">Location</p>
          <p className="text-lg">{classData?.location || 'Main Studio'}</p>
          {classData?.location_address && (
            <p className="text-sm text-neutral-400 mb-4">{classData.location_address}</p>
          )}
          {!classData?.location_address && <div className="mb-4"></div>}
          <p className="text-sm text-neutral-400 mb-2">Amount Paid</p>
          <p className="text-2xl font-bold text-success">£{paidAmount || appliedDiscount?.final_price || classData?.price}</p>
          {appliedDiscount && (
            <p className="text-xs text-neutral-500 mt-1">
              <span className="line-through">£{classData?.price}</span>
              <span className="ml-2 text-success">(Discount applied: {appliedDiscount.code})</span>
            </p>
          )}
        </div>
        <div className="bg-info/10 border border-info/30 rounded-sm p-4 mb-8">
          <p className="text-sm text-info">
            A confirmation email has been sent to <span className="font-bold">{userEmail}</span>
          </p>
        </div>
        <div className="flex gap-4 justify-center">
          <Link to="/dashboard">
            <Button className="bg-primary hover:bg-primary-hover font-bold" data-testid="go-to-dashboard-btn">
              VIEW MY BOOKINGS
            </Button>
          </Link>
          <Link to="/classes">
            <Button variant="outline" data-testid="browse-more-btn">
              BROWSE MORE CLASSES
            </Button>
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default BookingConfirmation;
